import utoniqDev from './configs/utoniqDev.json'
import utoniqStg from './configs/utoniqStg.json'
import utoniq from './configs/utoniq.json'
import getConfig from 'next/config'

const {
  publicRuntimeConfig: { firebaseProjectId },
} = getConfig()

const standalones =
  {
    'utoniq-dev': utoniqDev,
    'utoniq-stg': utoniqStg,
    utoniq: utoniq,
  }[firebaseProjectId] || {}

export default standalones
